/**
 * Amp Skimlinks
 * @category Functional Component
 * @summary Display the skimlinks disclaimer and includes the JS lib.
 * @prop {object} data - The page data.
 * @prop {object} type - The disclaimer type.
 * @return {Node} React node containing the skimlinks disclaimer.
 */

const AmpSkimlinks = props => {
  const { data, type } = props;
  const disclaimer = data.skimlinksQuery[type];

  return (
    <>
      <amp-skimlinks layout='nodisplay' publisher-code={ data.skimlinksQuery.skimlinks_publisher_code }></amp-skimlinks>
      <div className='amp-content__disclaimer'>
        { disclaimer }
      </div>
    </>
  );
}

export default AmpSkimlinks;
